import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { http, formatApiError } from "@/lib/api";

export const DeleteRequestButton = ({ requestId, onDeleted }) => {
  const remove = async () => {
    try {
      await http.delete(`/admin/requests/${requestId}`);
      toast.success("Dados excluídos.");
      onDeleted();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className="inline-flex items-center gap-2 text-xs text-red-400/80 hover:text-red-300" data-testid="delete-request-btn"><Trash2 className="h-3.5 w-3.5" /> Excluir dados (LGPD)</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="border-white/10 bg-[#141C2E] text-slate-100">
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir dados desta solicitação?</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">Solicitação, pontuação, agendamento, observações e histórico serão removidos definitivamente. A ação ficará registrada na auditoria.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-white/10 bg-transparent text-slate-300">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={remove} className="bg-red-600 text-white hover:bg-red-500" data-testid="delete-request-confirm">Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
